import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Send, MessageSquare } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Messages() {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = () => api.get("/messages").then((r) => setMsgs(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post("/messages", { body: text.trim() });
      setText("");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setSending(false); }
  };

  return (
    <DashboardLayout title="Messaggi">
      <div className="max-w-2xl mx-auto flex flex-col h-[calc(100vh-9rem)]">
        <div className="flex-1 overflow-auto rounded-2xl border border-slate-200 bg-white p-4 sm:p-6 space-y-3" data-testid="messages-thread">
          {msgs.length === 0 && (
            <div className="h-full flex flex-col items-center justify-center text-slate-400">
              <MessageSquare className="h-10 w-10" />
              <p className="mt-3 text-sm">Nessun messaggio. Qui riceverai aggiornamenti e riepiloghi dal team.</p>
            </div>
          )}
          {msgs.map((m) => {
            const mine = m.sender_role === "segnalatore";
            return (
              <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-wrap ${mine ? "bg-[#0A1128] text-white rounded-br-sm" : "bg-[#D4AF37]/15 text-slate-800 rounded-bl-sm border border-[#D4AF37]/30"}`}>
                  {!mine && <p className="text-[11px] font-semibold text-[#8a6d0f] mb-1">{m.sender_name || "Team"}</p>}
                  {m.body}
                  <p className={`text-[10px] mt-1 ${mine ? "text-white/50" : "text-slate-400"}`}>{new Date(m.created_at).toLocaleString("it-IT")}</p>
                </div>
              </div>
            );
          })}
          <div ref={endRef} />
        </div>
        <form onSubmit={send} className="mt-3 flex items-center gap-2">
          <input value={text} onChange={(e) => setText(e.target.value)} data-testid="message-input"
            placeholder="Scrivi un messaggio al team…"
            className="flex-1 rounded-full border border-slate-200 px-5 py-3 text-sm focus:border-[#D4AF37] focus:outline-none" />
          <button disabled={sending} data-testid="message-send-btn" className="btn-gold rounded-full h-12 w-12 flex items-center justify-center shrink-0">
            <Send className="h-5 w-5" />
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
}
